<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="text-body">
          This badge will attach to the profile pic displayed in the app for all
          members of your team.
          <span
            class="text-decoration-underline cursor-pointer"
            @click="showDialog = true"
            >See example.</span
          >
        </div>
      </v-col>
      <v-col cols="7">
        <v-col cols="12">
          <UploadImageDialog
            :show="showUploadImageDialog"
            isDisplayImage
            previewType="displayImageURL"
            @close="showUploadImageDialog = false"
            @uploaded="handleUploaded"
            :applyImageCompression="true"
            :image="editImageURL"
            ref="uploadImageDialog"
            :isBadgeOrQrCode="true"
            :uploadToBusinessProfile="false"
          />
          <div class="d-flex flex-wrap justify-start align-center">
            <div class="mr-6">
              <AddNewImage
                @click="showUploadImageDialog = true"
                :size="140"
                text="Add new logo"
                :isCircle="true"
              />
            </div>
            <div
              v-for="(image, index) in imageList"
              :key="`badgeImage${index}`"
            >
              <v-hover v-slot="{ hover }">
                <v-sheet
                  :class="[
                    { selected: selectedImage == image },
                    'circle d-flex justify-center align-center mr-6 my-6',
                  ]"
                  :outlined="selectedImage == image ? false : true"
                  width="140"
                  height="140"
                  @click="selectedImage = image"
                >
                  <v-img :src="image" class="circle" width="137" height="137">
                    <div
                      class="text-center mt-3"
                      v-show="
                        hover &&
                        !defaultImages.includes(image) &&
                        !(selectedImage == image)
                      "
                    >
                      <v-btn
                        :key="`edit${index}`"
                        fab
                        x-small
                        color="white"
                        class="mr-1"
                        @click.stop="handleEdit(image)"
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          color="secondary"
                        >
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        :key="`delete${index}`"
                        @click.stop="handleDelete(image)"
                        fab
                        x-small
                        color="white"
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          color="secondary"
                        >
                          mdi-trash-can
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-img>
                </v-sheet>
              </v-hover>
            </div>
          </div>
        </v-col>
      </v-col>
      <!--Start: Fixed column-->
      <v-col cols="5">
        <div class="text-right">
          <v-btn
            width="150"
            color="primary"
            depressed
            large
            :disabled="isSaveDisabled"
            class="text-body-1"
            @click="handleSave"
            >Save</v-btn
          >
        </div>

        <div class="pt-10 mt-10">
          <Badge :size="250" :logo="badgeImageUrl" />
        </div>
      </v-col>

      <!--End: Fixed column-->
    </v-row>

    <v-dialog v-model="showDialog" width="700">
      <v-card height="100%">
        <div class="justify-space-between d-flex align-center mx-2">
          <div>
            <v-card-title class="justify-start">
              Example of Business Badge
            </v-card-title>
          </div>
          <div class="text-right">
            <v-btn fab text small @click="showDialog = false" right
              ><v-icon>close</v-icon></v-btn
            >
          </div>
        </div>

        <v-card-text class="d-flex justify-center pb-0" style="height: 100%">
          <div class="d-flex flex-column align-center justify-center">
            <img
              src="@/assets/image 23.svg"
              class="ml-16"
              height="120"
              width="120"
            />
            <img
              src="@/assets/image 24.svg"
              height="120"
              class="ml-n4"
              width="120"
            />
            <img
              src="@/assets/image 25.svg"
              class="ml-16"
              height="120"
              width="120"
            />
          </div>
          <div class="d-flex mt-2 pt-0" style="position: relative">
            <img
              src="@/assets/Ellipse 148.svg"
              height="340"
              width="340"
              class="ml-13 pl-8 mt-n13"
              style="position: relative"
            />
            <img
              src="@/assets/image 22.svg"
              style="position: absolute; bottom: 0"
              height="380"
              width="400"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Badge from "@/components/BadgeAndQRCode/Badge";
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import { mapActions, mapGetters } from "vuex";
import {getFirestore, writeBatch} from "firebase/firestore";
import {businessCardsDocRef, getBusinessCardsDoc} from "@/shared/firebase_utils";

export default {
  components: {
    Badge,
    AddNewImage,
    UploadImageDialog,
  },
  created() {
    this.selectedImage = this.businessProfile.badgeImageURL || "";
    this.imageList = this.getImageList();
  },
  data() {
    return {
      showUploadImageDialog: false,
      defaultImages: [
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_1.png?alt=media&token=eaaa4308-db9d-4b4d-9ad4-828ac7454ab7",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_2.png?alt=media&token=e2112092-7b35-4a75-987f-dd542ce8b9e2",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_3.png?alt=media&token=30456377-366c-4a8d-aaeb-2c3db9568210",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_4.png?alt=media&token=c9111f1a-c150-4847-b2ef-2fb657d1beff",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_5.png?alt=media&token=fd78d284-470e-4bd6-9b7e-cb7ebad926f0",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_6.png?alt=media&token=2f55f010-cbec-4d89-9058-9f43a397a7bb",
      ],
      imageList: [],
      selectedImage: "",
      editImageURL: "",
      showDialog: false,
    };
  },
  computed: {
    ...mapGetters(["businessProfile", "cardHolders"]),
    badgeImageUrl() {
      let badgeImageURL = this.selectedImage ? this.selectedImage : "";

      return badgeImageURL;
    },
    isSaveDisabled() {
      if (
        this.selectedImage == this.businessProfile.badgeImageURL ||
        this.selectedImage == ""
      )
        return true;
      else return false;
    },
  },
  watch: {
    "businessProfile.badgeQRImageURLs": function () {
      this.imageList = this.getImageList();
    },
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),

    getImageList() {
      let imageList = [];

      if (this.selectedImage) {
        //Push all default images to imageList except selectedImage
        imageList = this.defaultImages.filter((imageURL) => {
          return imageURL != this.selectedImage;
        });
        //Add selected image at index 0
        imageList.unshift(this.selectedImage);
      } else imageList = [...this.defaultImages];

      if (
        this.businessProfile.badgeQRImageURLs?.length != 0 &&
        this.businessProfile.badgeQRImageURLs != undefined
      ) {
        let insertAtIndex = imageList.indexOf(this.selectedImage) == -1 ? 0 : 1;
        //Insert images uploaded by user at second index onwards.
        imageList.splice(
          insertAtIndex,
          0,
          ...this.businessProfile.badgeQRImageURLs?.filter((imageURL) => {
            return imageURL != this.selectedImage;
          })
        );
      }

      return imageList;
    },
    async handleUploaded(downloadURL) {
      this.selectedImage = downloadURL;

      let badgeQRImageURLs = [];
      if (this.businessProfile.badgeQRImageURLs)
        badgeQRImageURLs = [
          downloadURL,
          ...this.businessProfile.badgeQRImageURLs,
        ];
      else badgeQRImageURLs.push(downloadURL);

      await this.updateBusinessProfileDetails({
        badgeQRImageURLs: badgeQRImageURLs,
      });
    },

    async handleSave() {
      await this.updateBusinessProfileDetails({
        badgeImageURL: this.selectedImage,
      });

      //update QR code logo in business card
      try {
        let db = getFirestore();
        let batch = writeBatch(db);

        this.cardHolders.forEach((cardHolder) => {
          let docRef = businessCardsDocRef(cardHolder.businessCardId);
          batch.update(docRef, { badgeImageURL: this.selectedImage });
        });
        this.showSnackbar({ show: true, text: "Badge updated successfully!" });

        await batch.commit();
      } catch (error) {
        console.log(
          "Error occurred while updating card holders details: ",
          error
        );
        this.showSnackbar({
          show: true,
          text: "Error occurred, please try again!",
        });
      }
    },
    async handleEdit(image) {
      this.editImageURL = image;

      //Fetch the image from url, convert to blob
      let res = await fetch(image);
      let blob = await res.blob();
      this.$refs.uploadImageDialog.fileAdded(blob);
      this.showUploadImageDialog = true;
    },
    async handleDelete(imageURL) {
      try {
        this.businessProfile.badgeQRImageURLs =
          this.businessProfile.badgeQRImageURLs?.filter((image) => {
            return image != imageURL;
          });
        await this.updateBusinessProfileDetails({
          badgeQRImageURLs: this.businessProfile?.badgeQRImageURLs,
        });
        this.showSnackbar({ show: true, text: "Deleted successfully!" });
      } catch (err) {
        console.log("Error occurred while deleting an uploaded image: ", err);
        this.showSnackbar({
          show: true,
          text: "Could not delete image, please try again!",
        });
      }
    },
  },
};
</script>

<style></style>
